<template>
  <div class="main">
    <div class="c-nav-tabs">
      <ul class="nav-tabs">
        <li>
          <router-link to="/pc/basis">基本信息</router-link>
        </li>
        <li class="active">
          <router-link to="/pc/account">账号信息</router-link>
        </li>
        <li>
          <router-link to="/pc/password">修改密码</router-link>
        </li>
      </ul>
    </div>
    <div class="m-main-wrap navs-tab">
      <div class="c-account-title">
        <div class="tit-con">
          <span class="icon icontemp block"></span>
          <strong class="tit">账号信息</strong>
        </div>
      </div>
      <div class="c-form">
        <div
          class="m-area"
          v-for="o in list"
          :key="o.fieldName"
          :class="{ 'text-shuang': o.displayName.length > 6 }"
        >
          <div class="form-row">
            <div class="form-label">{{ o.displayName }}</div>
            <div class="form-contro">
              <input
                type="text"
                class="form-input"
                disabled
                v-model="o.model"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="c-account-title u-mt20">
        <div class="tit-con">
          <span class="icon icontemp block"></span>
          <strong class="tit">第三方账号绑定信息</strong>
        </div>
      </div>
      <div class="c-account-bind">
        <div class="list" v-if="oauthInfo && oauthInfo.qq">
          <div class="third-tool">
            <div class="third-img" v-if="!bindInfo.qq">
              <span class="icon icontemp qq"></span>
            </div>
            <div class="third-img" v-if="bindInfo.qq">
              <img :src="bindInfo.qq.headImgUrl" />
            </div>
            <div class="third-tit">
              {{ bindInfo["qq"] ? bindInfo["qq"].nickname : "QQ" }}
            </div>
          </div>
          <button class="m-bind" @click="unBindThird('qq')" v-if="bindInfo.qq">
            <span class="icon icontemp unlocking"></span>
            <span class="text">解绑</span>
          </button>
          <button class="m-bind" @click="bindThird('qq')" v-if="!bindInfo.qq">
            <span class="icon icontemp locking"></span>
            <span class="text">绑定</span>
          </button>
        </div>
        <div class="list" v-if="oauthInfo && oauthInfo.wechat">
          <div class="third-tool">
            <div class="third-img" v-if="!bindInfo.wechat">
              <span class="icon icontemp wechat"></span>
            </div>
            <div class="third-img" v-if="bindInfo.wechat">
              <img :src="bindInfo.wechat.headImgUrl" />
            </div>
            <div class="third-tit">
              {{ bindInfo.wechat ? bindInfo.wechat.nickname : "微信" }}
            </div>
          </div>
          <button
            class="m-bind"
            @click="unBindThird('wechat')"
            v-if="bindInfo.wechat"
          >
            <span class="icon icontemp unlocking"></span>
            <span class="text">解绑</span>
          </button>
          <button
            class="m-bind"
            @click="bindThird('wechat_web')"
            v-if="!bindInfo.wechat"
          >
            <span class="icon icontemp locking"></span>
            <span class="text">绑定</span>
          </button>
        </div>
      </div>
    </div>
<!--    <div class="m-loading-data" v-if="isLoading"></div>-->
    <van-popup v-model="show">
      <div class="c-confirm-alert">
        <div class="ca-header">
          <span class="icon icontemp stemp-close" @click="hideAlert()"></span>
        </div>
        <div class="ca-main">
          解绑后该{{ unstr == "qq" ? "QQ" : "微信" }}号将无法用户账号登陆<br />
          确定解绑么？
        </div>
        <div class="ca-footer">
          <button class="m-button-btn confirm" @click="confirmUnBind()">
            确定
          </button>
          <button class="m-button-btn cancel" @click="hideAlert()">
            我再想想
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { $subscriber } from "fire-wind-water/tools/subscriber";
import { cr } from "fire-wind-water/core";
import { URLS } from "fire-wind-water/url";
import member from "../../services/member";
import { sess } from "../../common/sbase";

export default {
  name: "Account",
  data() {
    return {
      list: [],
      bindInfo: {},
      oauthInfo: {},
      isLoading: true,
      show: false,
      unstr: "",
      errorText: URLS.getURL("error")
    };
  },
  methods: {
    init() {
      $subscriber.subscribe("s-member-contact", data => {
        this.initList(data[0], data[1]);
        this.isLoading = false;
        window.$sk.loading.hide();
      });
      $subscriber.on("s-contact-init", o => {
        this.isLoading = false;
        window.$sk.loading.hide();
        this.bindInfo = o.bindInfo;
      });
    },
    initList(m, o) {
      this.bindInfo = o.bindInfo;
      this.oauthInfo = m.oauthInfo;
      if (!this.bindInfo || cr.isArray(this.bindInfo)) {
        this.bindInfo = {};
      }
      this.list = [];
      cr.each(m.items, d => {
        if (d.isLogin == 1) {
          d.model = o.fieldInfo[d.fieldName] || null;
          this.list.push(d);
        }
      });
    },
    hideAlert() {
      this.show = false;
    },
    bindThird(s) {
      let loginUrl = URLS.updateParam("sess", sess, this.oauthInfo[s].loginUrl);
      let urls = URLS.removeSearchParam(window.location.href, "error");
      loginUrl = URLS.updateParam(
        "return_url",
        encodeURIComponent(urls),
        loginUrl
      );
      window.location.href = loginUrl;
    },
    unBindThird(s) {
      this.show = true;
      this.unstr = s;
    },
    confirmUnBind() {
      const info = {
        provider: this.unstr,
        sess: sess
      };
      this.isLoading = true;
      member.unbind(info).subscribe(data => {
        if (data.result == "0") {
          this.$message.success("解绑成功");
          this.show = false;
          $subscriber.emit("s-contact-get");
        } else {
          this.$message.error(data.desc);
          this.isLoading = false;
        }
      });
    }
  },
  created() {
    this.init();
    if (this.errorText) {
      this.$message.error(decodeURIComponent(this.errorText));
    }
  },
  destroyed() {
    if (this.errorText) {
      window.location.href = URLS.removeSearchParam(
        window.location.href,
        "error"
      );
    }
  }
};
</script>

<style scoped></style>
